/** import Layout files */
import './layout/menu';

/** import components files */
import './components/caroussel';
import './components/engagement-caroussel';
import './components/show-more-btn';
import './components/laureat';
import './components/partenaires-caroussel';
import './components/mentors-transitions';
import './components/selection-process';

